'use no memo';

import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import type { ChangeEvent } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { FillScreen, HStack } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { PublicIdsDataTable } from './-components/PublicIdsDataTable';
import { PublicIdsTabs } from './-components/PublicIdsTabs';
import { usePublicIdsSearch } from './-hooks/usePublicIdsSearch';
import { SearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/public-ids/_list/registry/')({
  validateSearch: zodValidator(SearchSchema),
  component: Registry
});
function Registry() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.publicIds'
  });
  useDocumentTitle(t('registry.pageTitle'));
  const {
    search,
    changeFreeText
  } = usePublicIdsSearch();
  const route = getRouteApi('/_staff/public-ids/_list/registry/');
  const navigate = route.useNavigate();
  const handleFilterInput = useDebouncedCallback((e: ChangeEvent<HTMLInputElement>) => changeFreeText(e.target.value), [changeFreeText]);
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <PublicIdsTabs />
        <span className="ml-auto">
          <ActionButton icon="PlusIcon" className="bg-primary-fill" onClick={() => navigate({
          to: '/public-ids/add'
        })}>
            {t('addPublicId')}
          </ActionButton>
        </span>
      </HStack>
      <HStack className="justify-between items-center p-2 rounded bg-background">
        <HStack className="gap-2">
          <SearchInput
        // NOTE:Public ID種別が変更された時に強制的に再レンダリングされるようにキーを設定
        key={`search-input-${search.publicIdType}`} className="w-44 h-8 shrink-0" placeholder={t('registry.filterPlaceholder')} defaultValue={search.freeText} onChange={handleFilterInput} />
        </HStack>
      </HStack>
      <PublicIdsDataTable />
    </FillScreen>;
}